<template>
  <div>
    <div class="terms-hero">
      <div class="container">
        <h1>{{ $t('terms.title') }}</h1>
        <p class="terms-hero__updated">{{ $t('terms.lastUpdated') }}</p>
      </div>
    </div>

    <section class="terms-section">
      <div class="terms-content">

        <p class="terms-intro">{{ $t('terms.intro') }}</p>

        <div class="terms-block">
          <h2>{{ $t('terms.s1Title') }}</h2>
          <p v-for="(item, i) in $tm('terms.s1Items')" :key="i">{{ item }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s2Title') }}</h2>
          <p v-for="(item, i) in $tm('terms.s2Items')" :key="i" v-html="item"></p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s3Title') }}</h2>
          <p>{{ $t('terms.s3p1') }}</p>
          <ul>
            <li v-for="(item, i) in $tm('terms.s3Items')" :key="i">{{ item }}</li>
          </ul>
          <p>{{ $t('terms.s3p2') }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s4Title') }}</h2>
          <p v-for="(item, i) in $tm('terms.s4Items')" :key="i">{{ item }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s5Title') }}</h2>
          <p>{{ $t('terms.s5p1') }}</p>
          <ul>
            <li v-for="(item, i) in $tm('terms.s5Items')" :key="i">{{ item }}</li>
          </ul>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s6Title') }}</h2>
          <p v-html="$t('terms.s6p1')"></p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s7Title') }}</h2>
          <p v-for="(item, i) in $tm('terms.s7Items')" :key="i">{{ item }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s8Title') }}</h2>
          <p>{{ $t('terms.s8p1') }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s9Title') }}</h2>
          <p>{{ $t('terms.s9p1') }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s10Title') }}</h2>
          <p v-for="(item, i) in $tm('terms.s10Items')" :key="i">{{ item }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s11Title') }}</h2>
          <p v-for="(item, i) in $tm('terms.s11Items')" :key="i" v-html="item"></p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s12Title') }}</h2>
          <p>{{ $t('terms.s12p1') }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s13Title') }}</h2>
          <p>{{ $t('terms.s13p1') }}</p>
        </div>

        <div class="terms-block">
          <h2>{{ $t('terms.s14Title') }}</h2>
          <p>{{ $t('terms.s14p1') }}</p>
          <div class="terms-card">
            <strong>{{ $t('terms.s14CardName') }}</strong><br />
            <a :href="`mailto:${$t('terms.s14CardEmail')}`">{{ $t('terms.s14CardEmail') }}</a>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'TermsPage',
  }
</script>

<style scoped>
.terms-hero {
  padding-top: 140px;
  padding-bottom: 60px;
  text-align: center;
  background: linear-gradient(180deg, rgba(91,141,184,0.07) 0%, transparent 100%);
}

.terms-hero h1 {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-bottom: 0.5rem;
}

.terms-hero__updated {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.terms-section {
  padding: 60px 2rem 100px;
}

.terms-content {
  max-width: 740px;
  margin: 0 auto;
}

.terms-intro {
  font-size: 1rem;
  line-height: 1.75;
  color: var(--text-muted);
  margin-bottom: 2.5rem;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid var(--border);
}

.terms-block {
  margin-bottom: 2.5rem;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid var(--border);
}

.terms-block:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.terms-block h2 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 0.75rem;
}

.terms-block p {
  font-size: 0.9rem;
  line-height: 1.75;
  color: var(--text-muted);
  margin-bottom: 0.75rem;
}

.terms-block p:last-child {
  margin-bottom: 0;
}

.terms-block ul {
  margin: 0.5rem 0 0.75rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.terms-block li {
  font-size: 0.9rem;
  line-height: 1.65;
  color: var(--text-muted);
}

.terms-block a {
  color: var(--primary);
  text-decoration: none;
  font-weight: 500;
}

.terms-block a:hover {
  text-decoration: underline;
}

.terms-card {
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 1rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.75;
  color: var(--text);
  margin-top: 0.75rem;
}

.terms-card a {
  color: var(--primary);
  font-weight: 500;
  text-decoration: none;
}

.terms-card a:hover { text-decoration: underline; }
</style>
